__webpack_require__.p = "/newkamal/";